<template>
  <div class="input">
    <div class="input-label">クイズ番号</div>
    <div class="input-group">{{ number }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    number: function () {
      return this.$store.state.quiz.number
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
